import { render, staticRenderFns } from "./customerDetails.vue?vue&type=template&id=3b11fd99"
import script from "./customerDetails.ts?vue&type=script&lang=js&external"
export * from "./customerDetails.ts?vue&type=script&lang=js&external"
import style0 from "./customerDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports